import { render, staticRenderFns } from "./ListChatPersons.vue?vue&type=template&id=229d0aee&scoped=true&"
import script from "./ListChatPersons.vue?vue&type=script&lang=js&"
export * from "./ListChatPersons.vue?vue&type=script&lang=js&"
import style0 from "./ListChatPersons.vue?vue&type=style&index=0&id=229d0aee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229d0aee",
  null
  
)

export default component.exports